<template>
  <div v-show="loading">
    <div class="flex space-x-8">
      <div
        class="ring-1 ring-gray-200 shadow rounded-md max-w-sm w-64"
        v-for="s in size"
        :key="s"
      >
        <div v-show="type == 'default'">
          <div class="animate-pulse flex space-x-4 p-4">
            <div class="rounded-full bg-gray-300 h-12 w-12"></div>
            <div class="flex-1 space-y-4 py-1">
              <div class="h-4 bg-gray-300 rounded w-3/4"></div>
              <div class="space-y-2">
                <div class="h-4 bg-gray-300 rounded"></div>
                <div class="h-4 bg-gray-300 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="type == 'session'">
          <div class="animate-pulse">
            <div class="bg-gray-300 h-48 w-auto"></div>
            <div class="flex-1 space-y-4 py-4 px-4">
              <div class="h-4 bg-gray-300 rounded w-4/12"></div>
              <div class="space-y-2">
                <div class="h-4 bg-gray-300 rounded"></div>
                <div class="h-4 bg-gray-300 rounded w-8/12"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="type == 'post'">
          <div class="animate-pulse p-4">
            <div class="flex space-x-4 h-32">
              <div class="rounded-full bg-gray-300 h-12 w-12"></div>
              <div class="flex-1 space-y-4 py-1">
                <div class="h-4 bg-gray-300 rounded w-auto"></div>
                <div class="space-y-2">
                  <div class="h-4 bg-gray-300 w-4/6 rounded"></div>
                </div>
              </div>
              <div class="h-4 bg-gray-300 rounded w-auto"></div>
            </div>
            <div class="flex-1 space-y-4 py-1">
              <div class="space-y-2">
                <div class="h-4 bg-gray-300 rounded w-5/6"></div>
                <div class="h-4 bg-gray-300 rounded w-3/6"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="type == 'trainer'">
          <div class="animate-pulse relative">
            <div class="flex justify-center h-24 bg-gray-300"></div>
            <div class="flex justify-center absolute items-center inset-0 h-40">
              <div class="rounded-full bg-gray-400 h-16 w-16"></div>
            </div>
            <div class="flex space-x-4 p-4 h-48">
              <div class="flex-1 space-y-4 py-1">
                <div class="flex justify-center">
                  <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                </div>
                <div class="flex justify-center">
                  <div class="h-4 bg-gray-300 rounded w-2/4"></div>
                </div>
                <div class="space-y-1">
                  <div class="h-8 bg-gray-400 rounded"></div>
                </div>
                <div class="space-y-2">
                  <div class="h-4 bg-gray-300 rounded w-6/6"></div>
                  <div class="h-4 bg-gray-300 rounded w-6/6"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentLoader",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {};
  },
};
</script>